import React from 'react';
import { withMyDataContext } from '../../context/DataProvider';
import Colors from '../Colors';
import NotLoggedIn from '../ErrorPages/NotLoggedIn';
import ButtonLoader from './ButtonLoader';
import Loader from './Loader';

class LoadingHelper extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loginDialog: false,
        }
    }
    render() {
        return (
            <div style={{marginTop:40, marginBottom:30}}>
                <NotLoggedIn active={this.state.loginDialog} onClose={() => this.setState({ loginDialog: false })}></NotLoggedIn>
                {this.props.myDataProvider.loadingState === "loading" || this.props.myDataProvider.loadingState === "connected"?
                    <div style={{display:"flex", alignItems:"center", justifyContent:"center"}}>
                        <Loader></Loader>
                    </div>
                : this.props.myDataProvider.loadingState === "disconnected" ?
                    <div style={{display:"flex", alignItems:"center", flexDirection:"column"}}>
                    <span style={{color:"#ccc"}}>You are not logged in yet</span>
                    <ButtonLoader
                        text="Log In"
                        style={{ backgroundColor: Colors.mainColor, padding: "12px 20px", width: "80%", marginTop: 10 }}
                        // icon={FacebookIcon}
                        onClick={() => this.setState({ loginDialog: true })}>
                    </ButtonLoader>
                </div>
                : null
            }      
            </div>
        );
    }
}

export default withMyDataContext(LoadingHelper)